import * as types from './constants';

// Get Contact Details
export const getContactDetailsRequest = data => (
  { type: types.GET_CONTACT_DETAILS_REQUEST, payload: data }
);

export const getContactDetailsDone = data => (
  { type: types.GET_CONTACT_DETAILS_DONE, payload: data }
);

export const getContactDetailsFailed = errors => (
  { type: types.GET_CONTACT_DETAILS_FAILED, payload: errors }
);

// Change Contact Details
export const changeContactRequest = data => (
  { type: types.CHANGE_CONTACT_REQUEST, payload: data }
);

export const changeContactDone = data => (
  { type: types.CHANGE_CONTACT_DONE, payload: data }
);

export const changeContactFailed = errors => (
  { type: types.CHANGE_CONTACT_FAILED, payload: errors }
);

// Actions
export const clearContactErrors = () => (
  { type: types.CLEAR_CONTACT_ERRORS }
);